import { Component, inject, OnInit, signal } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";

import { AuthLayoutComponent, FormInputComponent } from "../../../shared/components";
import { LoginRequest, MainResponseModel } from "../../../shared/models";
import { LoginService, RecaptchaService } from "../../../shared/services";

@Component({
  selector: "adaa-forget-password",
  templateUrl: "./forget-password.html",
  styleUrl: "./forget-password.scss",
  imports: [TranslatePipe, ReactiveFormsModule, RouterModule, FormInputComponent, AuthLayoutComponent],
})
export class ForgetPasswordComponent implements OnInit {
  private _formBuilder = inject(FormBuilder);
  private _recaptchaService = inject(RecaptchaService);
  private _loginService = inject(LoginService);

  forgetPasswordForm = signal<FormGroup | undefined>(undefined);
  resetDone = signal<boolean>(false);

  public ngOnInit(): void {
    this._recaptchaService.appendReCAPTCHA();

    this._prepareForm();
  }

  public submit(): void {
    const form = this.forgetPasswordForm();
    if (!form) return;

    this._recaptchaService.getToken("login", (token) => {
      form.get("captchaToken")?.setValue(token);

      if (!form.valid) return;

      this._loginService.resetPassword(form.value as LoginRequest).subscribe((response: MainResponseModel) => {
        if (response.responseCode === "1") this.resetDone.set(true);
      });
    });
  }

  /**
   * @description To prepare the login form, and to get the token from
   * google captcha.
   */
  private _prepareForm(): void {
    const form = this._formBuilder.group({
      captchaToken: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      token: [""],
      uuid: [""],
    });

    this.forgetPasswordForm.set(form);
  }
}
